<template>
  <div class="con" :class="{'dark':active2}">
    <div class="main">
      <a href="/index.html">
        <img class="a" src="../assets/yz/topLogo.png" alt />
        <img class="b" src="../assets/top2.png" alt />
      </a>

      <div class="info">
        <ul class="ulOne">
          <li class="liOne proLi" @click="showList">
            <a :class="page === 'pro' ? 'showLine' : ''">products</a>
          </li>

          <li class="liOne soLi" @click="showList2">
            <a :class="page === 'solution' ? 'showLine' : ''">solutions</a>
          </li>

          <li class="liOne abLi" @click="showList4">
            <a :class="page === 'about' ? 'showLine' : ''">about us</a>
          </li>

          <li class="liOne spLi" @click="showList3">
            <a :class="page === 'support' ? 'showLine' : ''">support</a>
          </li>

          <li class="liOne maLi" @click="showList5">
            <a :class="page === 'media' ? 'showLine' : ''">media center</a>
          </li>
        </ul>
        <div class="search">
          <input  :class="{'searchdark':active2}"
            type="text"
            :placeholder="placeholder"
            v-model="keywords"
            @focus="setNull"
            @blur="getVal"
          />
          <span @click="gotoSearch">
            <i class="iconfont icon-sousuo" :class="{'idark':active2}"></i>
          </span>
        </div>
        <div class="right">
          <img style="cursor: pointer" src="../assets/yz/topRight.png" alt @click="gotoNew" />
          <div class="line" @click="showTop">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div class="cateAll">
      <div class="content">
        <ul class="cateOne">
          <li>Products</li>
          <li
            v-for="(item,index) in cateOne"
            :key="index"
            :class="{'active':select1===index}"
            @mouseenter="getCateTwo(item.ID,index)"
            @click="gotoSmart(index)"
          >{{item.CALLED}}</li>
        </ul>
        <ul class="cateTwo">
          <li
            v-for="(item,index)  in cateTwo"
            :key="index"
            :class="{'active2':select2===index}"
            @mouseenter="getCateThree(item.ID,index)"
            @click="gotoPage(index)"
          >{{item.CALLED}}</li>
        </ul>
        <ul class="cateTwo">
          <li
            v-for="(item,index)  in cateThree"
            :key="index"
            :class="{'active3':select3===index}"
            @mouseenter="getCateFour(item.ID,index)"
          >{{item.CALLED}}</li>
        </ul>
        <ul class="cateTwo">
          <li
            v-for="(item,index)  in cateFour"
            :key="index"
            @click="gotoPro(item.ID)"
          >{{item.CALLED}}</li>
        </ul>
      </div>
    </div>
    <div class="solution">
      <div class="content">
        <div>
          <p class="markets">Markets</p>
          <ul class="tList">
            <li @click="gotoSolution(0)">Healthcare</li>
            <li @click="gotoSolution(1)">Education</li>
            <!-- <li @click="gotoSolution(2)">Industry</li> -->
            <li @click="gotoSolution(3)">Transportation</li>
            <li @click="gotoSolution(4)">Finance</li>
          </ul>
        </div>
          <div>
              <p class="application">Applications</p>
              <ul class="tList2">
                  <li @click="gotoApp(0)">Power over Ethernet (PoE)</li>
              </ul>
          </div>
      </div>

    </div>
    <div class="about">
      <div class="content">
        <ul>
          <li @click="gotoAbout(0)">About Vivanco</li>
          <li @click="gotoAbout(1)">Manufacturing</li>
          <li @click="gotoAbout(2)">R&D Center</li>
          <li @click="gotoAbout(3)">Global Presence</li>
        </ul>
      </div>
    </div>
    <div class="support">
      <div class="content">
        <ul>
          <li @click="gotoSupport(0)">Warranty</li>
          <li @click="gotoSupport(1)">Download</li>
          <li @click="gotoSupport(2)">Technical Support</li>
          <!-- <li @click="gotoSupport(3)">Training Course</li> -->
          <li @click="gotoSupport(4)">Knowledge Base</li>
        </ul>
      </div>
    </div>
    <div class="media">
      <div class="content">
        <ul>
          <li @click="gotoMedia(0)">News</li>
          <li @click="gotoMedia(1)">Events</li>
        </ul>
      </div>
    </div>

    <div class="topMenu" :class="{'showMenu':topMenu}">
      <div class="list">
        <img src="../assets/i8.png" alt @click="hideTop" />
        <div class="nav">
          <div class="right" v-for="(item,index) in rightList" :key="index">
            <p v-for="(i,ind) in item.conList" :key="ind" @click="goto(index,ind)">{{i}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="top animated fadeInUp">
      <a href="/index.html">
        <img class="a" src="../assets/yz/topLogo.png" alt />
      </a>
      <a href="/index.html">
        <img class="b" src="../assets/top2.png" alt />
      </a>
      <div class="mNav" :class="{active: menuOpen}" @click="menuOpen=!menuOpen">
        <span class="burger"></span>
        <span class="burger"></span>
        <span class="burger"></span>
      </div>
    </div>
    <div class="menuBox" :class="{open: menuOpen}">
      <a href="/pro.html" :class="page === 'pro' ? 'showLine' : ''">
        <li>products</li>
      </a>
      <a href="/health.html" :class="page === 'solution' ? 'showLine' : ''">
        <li>solutions</li>
      </a>
      <a href="/about.html" :class="page === 'about' ? 'showLine' : ''">
        <li>about us</li>
      </a>
      <a href="/support.html" :class="page === 'support' ? 'showLine' : ''">
        <li>support</li>
      </a>
      <a href="/media.html" :class="page === 'media' ? 'showLine' : ''">
        <li>media center</li>
      </a>
      <a href="/contact.html" :class="page === 'media' ? 'showLine' : ''">
        <li>Contact Us</li>
      </a>
    </div>
  </div>
</template>

<script>
import Scrollbar from "smooth-scrollbar";
import { getProductstypeUrl2 } from "../util/lang";
import "../common/jquery-1.11.3.min";
export default {
  name: "first",
  data() {
    return {
      select1: "",
      select2: "",
      select3: "",
      cateOne: "",
      cateTwo: "",
      cateThree: "",
      cateFour: "",
      placeholder: "Keyword, Part Number & More",
      rightList: [
        {
          conList: [
            "About Vivanco",
            "About Us",
            "Manufacturing",
            "R&D Center",
            "Global Presence"
          ]
        },
        { conList: ["Contact Us", "World Headquarters", "Find a Distributor"] },
        {
          conList: ["Download Center", "Catalogue", "Video", "Case Study"]
        },
        { conList: ["Technical Support", "Warranty", "Training Course","Knowledge Base"] },
        { conList: ["Media Center", "News", "Events"] },
        { conList: ["Join Us", "To be a Distributor", "Careers at Vivanco"] }
      ],
      topMenu: false,
      showa: true,
      select: 0,
      keywords: "",
      menuOpen: false,
      active2: false,
      scrollbar: "",
      top: "",
      list: [
        "HOME",
        "ABOUT US",
        "PRODUCTS",
        "FAQ",
        "NEW ARRIVALS",
        "CONTACT US"
      ]
    };
  },
  props: ["page"],
  // watch: {
  //     $route: 'getScrollbar'
  // },
  mounted() {
    this.$nextTick(() => {
      this.getScrollbar();
      this.getPro();
    });
    $(document).ready(function() {
      $(".markets").hover(function() {
        $(this).css({ color: "#91C131" });
        $('.application').css({ color: "white" });
        $(".tList").animate({ opacity: "1" });
        $(".tList2").animate({ opacity: "0" });
      });
      $(".application").hover(function() {
        $(this).css({ color: "#91C131" });
        $('.markets').css({ color: "white" });
        $(".tList2").animate({ opacity: "1" });
        $(".tList").animate({ opacity: "0" });
      });

      $(".proLi").hover(function() {
        $(".soLi a").removeClass("showLine");
        $(".spLi a").removeClass("showLine");
        $(".abLi a").removeClass("showLine");
        $(".maLi a").removeClass("showLine");
        $(".proLi a").addClass("showLine");
      });


      $(".soLi").hover(function() {
        $(".proLi a").removeClass("showLine");
        $(".abLi a").removeClass("showLine");
        $(".maLi a").removeClass("showLine");
        $(".spLi a").removeClass("showLine");
        $(".soLi a").addClass("showLine");
      });
      $(".abLi").hover(function() {
        $(".proLi a").removeClass("showLine");
        $(".spLi a").removeClass("showLine");
        $(".maLi a").removeClass("showLine");
        $(".soLi a").removeClass("showLine");
        $(".abLi a").addClass("showLine");
      });
      $(".spLi").hover(function() {
        $(".proLi a").removeClass("showLine");
        $(".abLi a").removeClass("showLine");
        $(".maLi a").removeClass("showLine");
        $(".soLi a").removeClass("showLine");
        $(".spLi a").addClass("showLine");
      });
      $(".maLi").hover(function() {
        $(".proLi a").removeClass("showLine");
        $(".abLi a").removeClass("showLine");
        $(".spLi a").removeClass("showLine");
        $(".soLi a").removeClass("showLine");
        $(".maLi a").addClass("showLine");
      });
      $(".cateAll").mouseleave(function () {
        $(".cateAll").slideUp()
        $(".proLi a").removeClass("showLine");
      })
      $(".solution").mouseleave(function () {
        $(".solution").slideUp()
        $(".soLi a").removeClass("showLine");
      })
      $(".about").mouseleave(function () {
        $(".about").slideUp()
        $(".abLi a").removeClass("showLine");
      })
      $(".support").mouseleave(function () {
        $(".support").slideUp()
        $(".spLi a").removeClass("showLine");
      })
      $(".media").mouseleave(function () {
        $(".media").slideUp()
        $(".maLi a").removeClass("showLine");
      })
    });
  },
  methods: {
    gotoPage(n){
      if(n==1){
        window.open('http://intl.vericomsolutions.com/products/data-center-infrastructure/micro-data-center-solutions/index.html','_blank')
      }else if(n==2){
        window.open('http://intl.vericomsolutions.com/products/data-center-infrastructure/aisle-containment-solutions/index.html','_blank')
      }
      // console.log(n)
    },
    gotoApp(n){
      if(n===0){
          window.open('./PoE.html','_self')
      }
    },
    gotoAbout(n){
      if (n === 0) {
        const link = "/about.html?index=0";
        window.open(link, "_self");
      } else if (n === 1) {
        const link = "/about.html?index=1";
        window.open(link, "_self");
      } else if (n === 2) {
        const link = "/about.html?index=2";
        window.open(link, "_self");
      } else {
        const link = "/about.html?index=3";
        window.open(link, "_self");
      }
    },
    gotoSupport(n) {
      if (n === 0) {
        const link = "/warranty.html";
        window.open(link, "_self");
      } else if (n === 1) {
        const link = "/support.html?index=1";
        window.open(link, "_self");
      } else if (n === 2) {
        const link = "/support.html?index=0";
        window.open(link, "_self");
      } else if(n === 3){
        const link = "/training.html";
        window.open(link, "_self");
      }else{
        const link = "/knowledge.html";
        window.open(link, "_self");
      }
    },
    gotoSolution(n) {
      if (n === 0) {
        const link = "/health.html";
        window.open(link, "_self");
      } else if (n === 1) {
        const link = "/education.html";
        window.open(link, "_self");
      }
      // else if (n === 2) {
      //   const link = "/industry.html";
      //   window.open(link, "_self");
      // } else if (n === 3) {
      //   const link = "/tran.html";
      //   window.open(link, "_self");
      // } else {
      //   const link = "/fina.html";
      //   window.open(link, "_self");
      // }
    },
    gotoPro(id) {
      const link = `/pro.html?id=${id}`;
      window.open(link, "_self");
    },
    gotoMedia(n){
      if (n === 0) {
        const link = "/media.html?index=0";
        window.open(link, "_self");
      } else if (n === 1) {
        const link = "/media.html?index=1";
        window.open(link, "_self");
      }
    },
    showList() {
      this.cateTwo = [];
      this.cateThree = [];
      this.cateFour = [];
      this.select1 = "";
      this.select2 = "";
      this.select3 = "";
      $(".solution").slideUp();
      $(".support").slideUp();
      $(".media").slideUp();
      $(".about").slideUp();
      $(".cateAll").slideToggle();
      $(".tList").animate({ opacity: "0" });
      $(".tList2").animate({ opacity: "0" });
    },
    showList2() {
      $(".cateAll").slideUp();
      $(".about").slideUp();
      $(".media").slideUp();
      $(".support").slideUp();
      $(".solution").slideToggle();
      $(".markets").css({ color: "white" });
      $(".application").css({ color: "white" });
      $(".tList2").animate({ opacity: "0" });
      $(".tList").animate({ opacity: "0" });
    },
    showList3() {
      $(".cateAll").slideUp();
      $(".about").slideUp();
      $(".media").slideUp();
      $(".solution").slideUp();
      $(".support").slideToggle();
      $(".markets").css({ color: "white" });
      $(".tList").animate({ opacity: "0" });
      $(".application").css({ color: "white" });
      $(".tList2").animate({ opacity: "0" });
    },
    showList4() {
      $(".cateAll").slideUp();
      $(".solution").slideUp();
      $(".support").slideUp();
      $(".media").slideUp();
      $(".about").slideToggle();
      $(".markets").css({ color: "white" });
      $(".tList").animate({ opacity: "0" });
      $(".application").css({ color: "white" });
      $(".tList2").animate({ opacity: "0" });
    },
    showList5() {
      $(".cateAll").slideUp();
      $(".about").slideUp();
      $(".support").slideUp();
      $(".solution").slideUp();
      $(".media").slideToggle();
      $(".markets").css({ color: "white" });
      $(".tList").animate({ opacity: "0" });
      $(".application").css({ color: "white" });
      $(".tList2").animate({ opacity: "0" });
    },
    getCateFour(id, n) {
      this.select3 = n;
      this.cateFour = [];
      setTimeout(() => {
        const url = `${getProductstypeUrl2("zh-CN", id)}`;
        this.$axios.get(url).then(res => {
          this.cateFour = res.data;
        });
      }, 200);
    },
    getCateThree(id, n) {
      this.select2 = n;
      this.select3 = "";
      this.cateFour = [];
      this.cateThree = [];
      setTimeout(() => {
        const url = `${getProductstypeUrl2("zh-CN", id)}`;
        this.$axios.get(url).then(res => {
          this.cateThree = res.data;
        });
      }, 200);
    },
    getCateTwo(id, n) {
      console.log(n)
      this.cateFour = [];
      this.cateThree = [];
      this.cateTwo = [];
      this.select1 = n;
      this.select2 = "";
      this.select3 = "";
      setTimeout(() => {
        const url = `${getProductstypeUrl2("zh-CN", id)}`;
        this.$axios.get(url).then(res => {
          this.cateTwo = res.data;
        });
      }, 200);
    },
    getPro() {
      this.$nextTick(() => {
        const url = `${getProductstypeUrl2("zh-CN", "42")}`;
        this.$axios.get(url).then(res => {
          this.cateOne = res.data;
          this.cateTwo = [];
          this.cateThree = [];
          this.cateFour = [];
        });
      });
    },
    setNull() {
      this.placeholder = "";
    },
    getVal() {
      this.placeholder = "Keyword, Part Number & More";
    },
    gotoSearch() {
      const link = `/pros.html?name=${this.keywords}`;
      window.open(link, "_self"); // this.project.link
    },
    showTop() {
      this.topMenu = true;
    },
    hideTop() {
      this.topMenu = false;
    },
    goto(n, i) {
      console.log(n,i)
      this.topMenu = false;
      setTimeout(() => {
        const alink = "/about.html";
        const alink2 = `/about.html?index=${i - 1}`;
        const clink = "/contact.html";
        const clink2 = "/contact2.html";
        const slink = "/support.html";
        const slink2 = `/warranty.html?index=${i - 1}`;
        const mlink = "/media.html";
        const mlink2 = `/media.html?index=${i - 1}`;
        const jlink = "/join.html";
        const jlink2 = `/join.html?index=${i - 1}`;
        // const dlink=`./support.html?index=${n - 1}?num=${i-1}`
        if (n === 1 && i === 0) {
          window.open(clink, "_self");
        } else if (n === 1 && i === 1) {
          window.open(clink, "_self");
        } else if (n === 1 && i === 2) {
          window.open(clink2, "_self");
        } else if (n === 3 && i === 0) {
          window.open(slink, "_self");
        } else if (n === 3 && i == 1) {
          window.open(slink2, "_self");
        } else if (n === 0 && i === 0) {
          window.open(alink, "_self");
        } else if (n === 0 && i !== 0) {
          window.open(alink2, "_self");
        } else if (n === 4 && i === 0) {
          window.open(mlink, "_self");
        } else if (n === 4 && i !== 0) {
          window.open(mlink2, "_self");
        } else if (n === 5 && i === 0) {
          window.open(jlink, "_self");
        } else if (n === 5 && i !== 0) {
          window.open(jlink2, "_self");
        } else if (n === 2 && i == 1) {
          window.open('./support.html?index=1?num=0', "_self");
        }else if (n === 2 && i == 2) {
          window.open('./support.html?index=1?num=4', "_self");
        }else if (n === 2 && i == 3) {
          window.open('./support.html?index=1?num=5', "_self");
        }
      }, 600);
    },
    gotoSmart(index){
      if(index==2){
        window.open('./smart.html','_self')
      }
    },
    gotoNew() {
      const link = "https://www.vivanco.com/";
      window.open(link);
    },
    scrollHeader(scrollTop) {
      this.active2 = scrollTop > 10 ? true : false;
    },
    getScrollbar() {
      this.$nextTick(() => {
        this.scrollbar = Scrollbar.get(
          document.getElementById("scroller-wrapper")
        );
        this.active2 = false;
        this.showa = true;
        this.select = parseInt(localStorage.getItem("index"));
        let scrollHeader = this.scrollHeader;
        if (this.scrollbar) {
          this.scrollbar.addListener(status => {
            scrollHeader(status.offset.y);
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.con {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  transition: all 600ms;
  background-color: #0000006e;
  .animated {
    animation-delay: 600ms;
  }
  .main {
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    border-radius: 5px;
    justify-content: space-between;
    padding-bottom: 15px;
    a {
      img {
        height: 87px;
        width: 122px;
        margin-top: 15px;
        cursor: pointer;
        padding-bottom: 10px;
        padding-left: 50px;
      }
      .a {
        display: block;
        transition: all 2s;
      }
      .b {
        display: none;
        transition: all 2s;
      }
    }

    .info {
      display: flex;
      flex-direction: row;
      width: 90%;
      justify-content: space-between;
      .ulOne {
        list-style: none;
        display: flex;
        flex-direction: row;
        color: white;
        justify-content: space-between;
        margin-top: 10px;
        width: 40%;
        margin-left: 5%;
        .liOne {
          color: white;
          line-height: 100px;
          text-transform: uppercase;
          font-family: "Fira Code Medium";
          font-weight: lighter;
          font-size: 15px;
          position: relative;
          padding: 0 5px;
          transition: all 600ms;
          cursor: pointer;
          a {
            color: white;
            display: inline-block;
            transition: all 600ms;
            &::before {
              position: absolute;
              left: 0;
              top: 50px;
              content: "";
              display: inline-block;
              height: 2px;
              width: 2px;
              background-color: #91c131;
              border-radius: 50%;
              transition: all 600ms;
              opacity: 0;
            }
            &::after {
              position: absolute;
              right: 0;
              top: 50px;
              content: "";
              display: inline-block;
              height: 2px;
              width: 2px;
              background-color: #91c131;
              border-radius: 50%;
              transition: all 600ms;
              opacity: 0;
            }
          }
          .showLine {
            color: #91c131;
            &::before {
              opacity: 1;
            }
            &::after {
              opacity: 1;
            }
          }
          &:hover {
            a {
              color: #91c131;
              &::before {
                opacity: 1;
              }
              &::after {
                opacity: 1;
              }
            }
          }
        }
        /*.proLi{*/
        /*  &:hover{*/
        /*    .cateAll{*/
        /*      display: block !important;*/
        /*    }*/
        /*  }*/
        /*}*/
      }
      .search {
        width: 30%;
        position: relative;
        // margin-left: 25%;
        input {
          -webkit-font-smoothing: antialiased;
          visibility: visible;
          box-sizing: border-box;
          font-family: "Fira Code Light";
          font-weight: lighter;
          border: none;
          border-radius: 0;
          width: 100%;
          color: #ffffff;
          font-size: 15px;
          padding-bottom: 10px;
          margin-top: 45px;
          background-color: transparent;
          border-bottom: 1px solid #cacaca;
        }
        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: white;
        }
        .searchdark{
          color: black;
        }
        .searchdark::-webkit-input-placeholder{
          color: black;
        }
        span {
          position: absolute;
          right: 0;
          cursor: pointer;
          i {
            color: white;
            font-size: 22px;
            line-height: 112px;
            transition: all 1s;
          }
          .idark{
            color: black;
          }
          &:hover {
            i {
              color: #91c131;
            }
          }
        }
      }
      .right {
        display: flex;
        flex-direction: row;
        margin-left: 5%;
        img {
          width: 38px;
          height: 26px;
          margin-top: 48px;
        }
        .line {
          width: 25px;
          height: 20px;
          margin-top: 50px;
          margin-left: 60px;
          position: relative;
          cursor: pointer;
          div:nth-child(1) {
            top: 0;
            width: 90%;
            height: 1px;
            background-color: rgba(255, 255, 255, 0.7);
            left: 0;
            position: absolute;
            animation: run1 2s linear infinite;
          }
          div:nth-child(2) {
            top: 10px;
            width: 100%;
            height: 1px;
            background-color: white;
            left: 0;
            position: absolute;
          }
          div:nth-child(3) {
            bottom: 0;
            width: 80%;
            height: 1px;
            background-color: rgba(255, 255, 255, 0.8);
            left: 0;
            position: absolute;
            animation: run2 2s linear infinite;
            animation-delay: 600ms;
          }
          @keyframes run1 {
            0% {
              width: 0;
            }
            25% {
              width: 45%;
            }
            50% {
              width: 90%;
            }
            75% {
              width: 45%;
            }
            100% {
              width: 0;
            }
          }
          @keyframes run2 {
            0% {
              width: 0;
            }
            25% {
              width: 40%;
            }
            50% {
              width: 80%;
            }
            75% {
              width: 40%;
            }
            100% {
              width: 0;
            }
          }
        }
      }
    }
  }
  .cateAll {
    left: 0;
    top: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    position: absolute;
    padding: 60px 0;
    display: none;
    height: 394px;
    .content {
      font-family: "Fira Code Medium";
      width: 1440px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      .cateOne {
        list-style: none;
        display: flex;
        flex-direction: column;
        li {
          font-family: "Fira Code Medium";
          color: white;
          line-height: 25px;
          margin: 10px 0;
          transition: all 600ms;
          position: relative;
          cursor: pointer;
          &:hover {
            color: #91c131;
          }
        }
        .active {
          color: #91c131;
        }
        li:first-child {
          font-size: 20px;
          font-weight: bold;
        }
      }
      .cateTwo {
        list-style: none;
        margin-left: 50px;
        margin-top: 45px;
        li {
          color: white;
          line-height: 25px;
          margin: 10px 0;
          transition: all 600ms;
          position: relative;
          cursor: pointer;
          &:hover {
            color: #91c131;
          }
        }
        .active2 {
          color: #91c131;
        }
        .active3 {
          color: #91c131;
        }
      }
    }
  }
  .solution {
    left: 0;
    top: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    position: absolute;
    padding: 60px 0;
    display: none;
    height: 394px;
    .content {
      font-family: "Fira Code Medium";
      width: 1440px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      div {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        width:50%;
        p {
          color: white;
          font-size: 20px;
          font-weight: bold;
          transition: all 600ms;
          width:150px;
          &:hover {
            color: #91c131;
          }
        }
        ul {
          padding-left: 50px;
          list-style: none;
          opacity: 0;
          li {
            font-family: "Fira Code Medium";
            color: white;
            font-weight: lighter;
            line-height: 40px;
            transition: all 600ms;
            &:hover {
              color: #91c131;
            }
          }
        }
      }
      div:nth-child(2){
        transform: translateY(-55px);
      }
    }
  }
  .about {
    left: 0;
    top: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    position: absolute;
    padding: 60px 0;
    display: none;
    height: 394px;
    .content {
      font-family: "Fira Code Medium";
      width: 1440px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      ul {
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: center;
        list-style: none;
        li {
          font-family: "Fira Code Medium";
          color: white;
          font-weight: lighter;
          line-height: 40px;
          transition: all 600ms;
          font-weight: bold;
          cursor: pointer;
          &:hover {
            color: #91c131;
          }
        }
      }
    }
  }
  .support {
    left: 0;
    top: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    position: absolute;
    padding: 60px 0;
    display: none;
    height: 394px;
    .content {
      font-family: "Fira Code Medium";
      width: 1440px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      ul {
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: center;
        list-style: none;
        li {
          font-weight: bold;
          font-family: "Fira Code Medium";
          color: white;
          // font-weight: lighter;
          line-height: 40px;
          transition: all 600ms;
          cursor: pointer;
          &:hover {
            color: #91c131;
          }
        }
      }
    }
  }
  .media {
    left: 0;
    top: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    position: absolute;
    padding: 60px 0;
    display: none;
    height: 394px;
    .content {
      width: 1440px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      font-family: "Fira Code Medium";
      ul {
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: center;
        list-style: none;
        li {
          font-family: "Fira Code Medium";
          color: white;
          font-weight: lighter;
          line-height: 40px;
          transition: all 600ms;
          font-weight: bold;
          cursor: pointer;
          &:hover {
            color: #91c131;
          }
        }
      }
    }
  }
  .topMenu {
    position: absolute;
    top: -700px;
    left: 0;
    width: 100%;
    height: 0;
    background: url(../assets/i4.jpg) no-repeat center;
    background-size: cover;
    transition: all 600ms;
    .list {
      width: 1400px;
      margin: 0 auto;
      position: relative;
      padding-top: 120px;
      img {
        position: absolute;
        right: -60px;
        top: 50px;
        cursor: pointer;
      }
      .nav {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
        .right {
          width: 25%;
          display: flex;
          flex-direction: column;
          padding-left: 30px;
          padding-right: 30px;
          margin-left: 2%;
          color: #8c8c8c;
          text-align: center;
          line-height: 30px;
          margin-top: 40px;
          p {
            cursor: pointer;
            transition: color 2s;
            color: white;
            line-height: 35px;
            font-family: "Fira Code Medium";
            font-weight: lighter;
          }
          p:first-child {
            color: white;
            padding-bottom: 10px;
            font-family: book;
            text-transform: uppercase;
          }
          p:hover {
            color: #91c131;
          }
        }
      }
    }
  }
  .showMenu {
    height: 700px;
    top: 0;
  }
  .top {
    display: none;
  }
  .menuBox {
    position: fixed;
    top: 90px;
    right: -100%;
    height: 100vh;
    width: 100%;
    background: #91c131;
    z-index: 1010;
    transition: 0.8s;
    display: block;
    padding-top: 50px;
  }
  .menuBox a {
    display: block;
    font-size: 18px;
    color: white;
    width: 80%;
    padding: 30px 0px;
    text-align: center;
    opacity: 0;
    transition: 0.8s;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    li {
      color: white;
      list-style: none;
      text-transform: uppercase;
    }
  }
  .menuBox.open {
    right: -25%;
    transform: rotate(-10deg);
    a {
      opacity: 1;
    }
  }
  @media screen and (min-width: 2200px) {
    .main {
      ul {
        width: 60%;
      }
    }
    .topMenu {
      .list {
        width: 87%;
        img {
          right: 125px;
        }
      }
    }
  }
  @media screen and (max-width: 1440px) {
    .main {
      width: 95%;
      margin-left: 2.5%;
      .search {
        margin-left: 1%;
        //     width:25%;
        //     input{
        //         font-size: 17px;
        //     }
        //     span{
        //         right:10px;
        //         i{
        //             font-size: 20px;
        //         }
        //     }
      }
      .info {
        width: 90%;
        .ulOne {
          width: 60%;
        }
        .search {
          margin-left: 5%;
        }
      }
    }
    .cateAll {
      padding: 30px 0;
      .content {
        width: 88%;
      }
    }
    .topMenu {
      .list {
        width: 95%;
        img {
          right: 125px;
        }
      }
    }
  }
  @media screen and (max-width: 1366px) {
    .topMenu {
      .list {
        img {
          right: 116px;
        }
      }
    }
  }
  @media screen and (max-width: 1200px) {
    .main,
    .topMenu {
      display: none;
    }
    .top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      padding: 20px 0px;
      transition: all 2s;
    }
    .top a:nth-child(1) {
      margin-left: 40%;
    }
    .top a:nth-child(2) {
      display: none;
      margin-left: 40%;
    }
    .a {
      height: 60px;
      object-fit: cover;
      display: block;
      transition: all 600ms;
    }
    .b {
      height: 60px;
      object-fit: cover;
      display: block;
      transition: all 600ms;
    }
    .mNav {
      display: block;
      transition: 0.8s;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      width: 60px;
    }
    .mNav .burger {
      width: 32px;
      height: 4px;
      background-color: white;
      position: absolute;
      top: 28px;
      left: 50%;
      margin: 0px 0px 0px -16px;
      transform-origin: center;
      transition: 0.8s;
    }
    .mNav .burger:nth-of-type(2) {
      top: 38px;
    }
    .mNav .burger:nth-of-type(3) {
      top: 48px;
    }
    .mNav.active {
      background-color: #91c131;
    }
    .mNav.active .burger {
      background-color: #fff;
    }
    .mNav.active .burger:nth-of-type(1) {
      top: 40px;
      transform: rotate(225deg);
    }
    .mNav.active .burger:nth-of-type(2) {
      left: -100%;
      opacity: 0;
    }
    .mNav.active .burger:nth-of-type(3) {
      top: 40px;
      transform: rotate(-225deg);
    }
  }
}
.dark {
  background-color: white;
  .main {
    a {
      .a {
        display: none;
      }
      .b {
        display: block;
      }
    }
    .search {
      input {
        color: black;
      }
      input::-webkit-input-placeholder {
        /* WebKit browsers */
        color: black;
      }
      span {
        i {
          color: black;
        }
      }
    }
    .info {
      .ulOne {
        .liOne {
          a {
            color: black;
          }
        }
      }
      .right {
        .line {
          div:nth-child(1) {
            background-color: rgba(0, 0, 0, 0.7);
          }
          div:nth-child(2) {
            background-color: black;
          }
          div:nth-child(3) {
            background-color: rgba(0, 0, 0, 0.8);
          }
        }
      }
    }
  }
  @media screen and (max-width: 1200px) {
    .top a:nth-child(1) {
      display: none;
    }
    .top a:nth-child(2) {
      display: block;
    }
    .mNav .burger {
      background-color: #91c131;
    }
  }
}
</style>
